import classNames from 'classnames';
import DpitMultiStateAnimBtn from './DpitMultiStateAnimBtn';

import {
	getActualVisibleNoticesHeight
} from './dp-admin-utils';

import {
	getCookie,
	setCookie,
	deleteCookie
} from '../../../../includes/assets/js/modules/dpitUtilsInc';
import { ANIM_DBG } from '../../../../public/assets/js/modules/core/constants';


export const CLASSES = {
	rootWrap: 'dpit-tool-bar',
	button: 'dpit-admin-btn',
	toolbarItem: 'dpit-tool-bar__item',
	buttonPrimary: 'button-primary',
	buttonSecondary: 'button-secondary'
};


export const IDS = {
	main: 'dpit-tool-bar',
	insertAfterEl: 'wp-admin-bar-top-secondary',
	wpAdminBar: 'wpadminbar'
};

export const BTN_ID = {
	primary: 'primary',
	draft: 'draft',
	view: 'view',
	preview: 'preview'
};

export default class DpitAdminToolbar {

	constructor(config, renderNow = true, previewButtonEnabled = true, onRedirectBtnClick = null, autoScrollToLastScrollTop = false, scrollTimeMs = 0) {
		if (config.dpDebugEn) console.log('[dpit] INIT DpitAdminToolbar');
		window.wpCookies = window.wpCookies || {};
		this.config = config;
		this.config.previewButtonEnabled = previewButtonEnabled;
		this.onRedirectBtnClick = onRedirectBtnClick;
		this.init(config);
		if (autoScrollToLastScrollTop) this.scrollToStoredScrollTop(scrollTimeMs);
		if (renderNow) this.render();
	}

	init() {
		this.adminBarEl = document.getElementById(IDS.wpAdminBar);
		if (this.adminBarEl) {
			this.insertAfterEl = this.adminBarEl.querySelector('#' + IDS.insertAfterEl);
			this.initStopWhenInvalidFormSubmitted();
		}
		this.buttons = {};
	}

	initStopWhenInvalidFormSubmitted() {
		$('#wpbody-content input').on('invalid', () => {
			this.stopPrimaryBtnAnimation();
		});
	}

	setIsChange() {
		this.isUnsavedChange = true;
	}

	activate() {
		this.wrapEl.classList.remove(CLASSES.rootWrap + '--inactive');
	}

	deactivate() {
		this.wrapEl.classList.add(CLASSES.rootWrap + '--inactive');
	}

	stopPrimaryBtnAnimation() {
		if (this.primaryBtn) this.primaryBtn.stopAnimation();
	}

	hideButtons(...btnIdsToHide) {
		if (btnIdsToHide) {
			btnIdsToHide.forEach(btnIdToHide => {
				if (this.buttons[btnIdToHide]?.element) {
					this.buttons[btnIdToHide]?.element.classList.add(CLASSES.toolbarItem + '--inactive');
				}
			});
		}
	}

	showButtons(...btnIdsToHide) {
		if (btnIdsToHide) {
			btnIdsToHide.forEach(btnIdToHide => {
				if (this.buttons[btnIdToHide]?.element) {
					this.buttons[btnIdToHide]?.element.classList.remove(CLASSES.toolbarItem + '--inactive');
				}
			});
		}
	}

	showOnlyButton(btnIdToShowOnly) {
		Object.keys(this.buttons).forEach(btnId => {
			if (btnId !== btnIdToShowOnly && this.buttons[btnId]?.element) {
				this.buttons[btnId].element.classList.add(CLASSES.toolbarItem + '--inactive');
			}
		});
	}

	render(activeOnLoad = true) {
		if (!this.wrapEl && this.insertAfterEl) {
			this.wrapEl = document.createElement('div');
			this.wrapEl.id = IDS.main;
			this.wrapEl.className = classNames([CLASSES.rootWrap, 'ab-top-secondary ab-top-menu']);
			this.renderButtons(this.wrapEl);

			this.insertAfterEl.after(this.wrapEl);
			// animate slide left
			if (activeOnLoad) addEventListener('load', this.activate.bind(this));
			else setTimeout(() => { this.activate(); }, 100);
		}
	}


	propagateButtonClick(localId) {
		if (this.buttons[localId]?.sourceEl) {
			this.buttons[localId].sourceEl.click();
		}
	}

	getToolbarItemModifiedClass(buttonId) {
		return CLASSES.toolbarItem + '--' + buttonId;
	}


	storeButtonData(buttonId, sourceEl, duplicatedEl) {
		this.buttons[buttonId] = {
			element: duplicatedEl,
			sourceEl: sourceEl
		};
	}

	animateAndPropagateClick(buttonId, button, actionTitle = '') {
		if (button) button.startAnimation();
		this.showOnlyButton(buttonId);
		this.storeCurrentScrollTop();
		if (this.onRedirectBtnClick) this.onRedirectBtnClick(buttonId, actionTitle);
		if (!ANIM_DBG) this.propagateButtonClick(buttonId);
	}

	checkUnsavedAnimateAndRedirectPropagateClick(buttonId, button, actionTitle = '') {
		if (!this.isUnsavedChange) {
			this.animateAndPropagateClick(buttonId, button, actionTitle);
		} else {
			this.storeCurrentScrollTop();
			this.propagateButtonClick(buttonId);
		}

	}

	renderButtons(wrapEl) {
		// primary button
		const primaryButtonEl = document.querySelector('#wpbody-content .wrap input[type="submit"].button-primary:not(.find-box input, .widget-control-save, #screen-options-wrap input, #bulk_edit)');
		if (primaryButtonEl) {
			this.primaryBtn = new DpitMultiStateAnimBtn(
				(args) => this.animateAndPropagateClick(BTN_ID.primary, args?.button, this.config.i18n.storingChanges),
				{ 'default': primaryButtonEl.value },
				'default',
				CLASSES.button,
				[CLASSES.toolbarItem, CLASSES.buttonPrimary]
			);
			if (this.primaryBtn) {
				this.storeButtonData(
					BTN_ID.primary,
					primaryButtonEl,
					this.primaryBtn.element
				);
			}
		}

		// draft button
		const draftButtonEl = $('#wpbody-content .wrap input[type="submit"]#save-post:visible:not(.find-box input)').get(0); // jquery becaluse of :visible:not(.find-box input)
		if (draftButtonEl) {
			this.draftBtn = new DpitMultiStateAnimBtn(
				(args) => this.animateAndPropagateClick(BTN_ID.draft, args?.button, this.config.i18n.storingChanges),
				{ 'default': draftButtonEl.value },
				'default',
				CLASSES.button,
				[CLASSES.toolbarItem, CLASSES.buttonSecondary]
			);
			if (this.draftBtn) {
				this.storeButtonData(
					BTN_ID.draft,
					draftButtonEl,
					this.draftBtn.element
				);
			}
		}

		if (this.config.previewButtonEnabled) {

			// preview post button
			const previewButtonEl = document.getElementById('post-preview');
			if (previewButtonEl) {
				let label = '';
				for (var i = 0; i < previewButtonEl.childNodes.length; ++i) {
					if (previewButtonEl.childNodes[i].nodeType === Node.TEXT_NODE) {
						label += previewButtonEl.childNodes[i].textContent;
					}
				}

				this.previewBtn = new DpitMultiStateAnimBtn(
					() => this.propagateButtonClick(BTN_ID.preview),
					{ 'default': label },
					'default',
					CLASSES.button,
					[CLASSES.toolbarItem, CLASSES.buttonSecondary]
				);
				if (this.previewBtn) {
					this.storeButtonData(
						BTN_ID.preview,
						previewButtonEl,
						this.previewBtn.element
					);
				}
			}
		}

		// view post button
		const viewPostButtonEl = document.querySelector('#wp-admin-bar-view a');
		if (viewPostButtonEl) {
			this.viewBtn = new DpitMultiStateAnimBtn(
				(args) => this.checkUnsavedAnimateAndRedirectPropagateClick(BTN_ID.view, args?.button, this.config.i18n.redirecting),
				{ 'default': viewPostButtonEl.textContent },
				'default',
				CLASSES.button,
				[CLASSES.toolbarItem, CLASSES.buttonSecondary]
			);
			if (this.viewBtn) {
				this.storeButtonData(
					BTN_ID.view,
					viewPostButtonEl,
					this.viewBtn.element
				);
			}
		}


		Object.keys(this.buttons).forEach(btnId => {
			if (this.buttons[btnId]) {
				wrapEl.appendChild(this.buttons[btnId].element);
			}
		});
	}


	clearCurrentScrollTopCookie() {
		deleteCookie('dpit-admin-edit-st');
	}

	storeCurrentScrollTop() {
		setCookie('dpit-admin-edit-st', document.documentElement.scrollTop - getActualVisibleNoticesHeight(), 60);
		console.log('storeCurrentScrollTop');
	}

	scrollToStoredScrollTop(scrollTimeMs = 0) {
		const storedScrollTopCookie = getCookie('dpit-admin-edit-st');
		if (storedScrollTopCookie) {
			let storedScrollTop = parseInt(storedScrollTopCookie, 10);
			if (!isNaN(storedScrollTop)) {
				storedScrollTop += getActualVisibleNoticesHeight();
				if (scrollTimeMs > 0) $(document.documentElement).animate({ scrollTop: storedScrollTop }, scrollTimeMs);
				else $(document.documentElement).scrollTop(storedScrollTop);
				return true;
			}
			this.clearCurrentScrollTopCookie();

		}
		return false;
	}
}

